import { applyMiddleware, createStore, compose } from "redux";
import { createReducers } from "./allReducers";
import { createSagas } from "./allSagas";
import { persistStore, persistReducer } from "redux-persist";
import createSagaMiddleware from "redux-saga";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: 'root',
  whitelist: [
    'auth',
    'persistentStore',
    'messaggio',
    'anagrafe',
    'profilazione',
    'screening',
    'screeningColonRetto',
    'screeningMammografico',
    'reset',
    'postLogin',
  ],
  storage: storage
}

const allReducers = createReducers();

const persistedReducer = persistReducer(persistConfig, allReducers);

export const configureStore = () => {
  const sagaMiddleware = createSagaMiddleware();
  const composeEnhancers = typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
  const store = createStore(persistedReducer, composeEnhancers(applyMiddleware(sagaMiddleware)));
  const persistor = persistStore(store);
  const allSagas = createSagas();
  sagaMiddleware.run(allSagas);
  return { store, persistor };
}